import { sortByStatus, sortByDate } from "../../../../utils/sortingFunctions";

const sortByType = {
    "status": sortByStatus,
    "date": sortByDate,
};

const sortRowsByType = (data, column, type, direction) => {
    const sortFunction = sortByType[type];

    if (!sortFunction) {
        throw new Error(`No sorting function found for type: ${type}`);
    }

    const sortedData = data.sort((a, b) => {
        return sortFunction(a[column], b[column], direction)
    });

    return sortedData;
};

export default sortRowsByType;